<div *ngIf="!mobileEditorToggle.IsMobile">
  <br />
  <ion-toggle
    class="mobilePreviewSwitch"
    (ionChange)="mobileEditorToggle.switchEditorToMobile()"
    [checked]="mobileEditorToggle.IsMobileEditor"
  >
    <ion-icon
      slot="start"
      [name]="
        mobileEditorToggle.IsMobileEditor ? 'phone-portrait' : 'desktop-outline'
      "
    ></ion-icon>
    {{ mobileEditorToggle.IsMobileEditor? ('mobile_editor.mobile_view' | translate): ('mobile_editor.desktop_view' | translate) }}
  </ion-toggle>
</div>
